import React from "react";
import { useParams } from "react-router-dom";
import '../assets/Home.css';
import LightBox from "../components/LightBox";

function SingleCustomization({ items }) {
    const { custIdx }  = useParams();
  
  return (
        <div id="single_customization">
            <div>
                <div className="cust_name">
                    <img src={items[custIdx].icon_url} alt={items[custIdx].name} loading="lazy"/>
                    <h3 style={{fontWeight: "normal", alignSelf: "center"}}>{items[custIdx].name}</h3>
                </div>

                <div className="cust_shortname">
                    <p>{items[custIdx].shortdesc}</p>
                </div>

                <LightBox item={items} custId={custIdx}/>

                <div>
                    <div className="long_desc" dangerouslySetInnerHTML={{__html: items[custIdx].longdesc}} />
                </div>
            </div>
        </div>
       
  );
}

export default SingleCustomization;
